import React from "react";
import { Col, Container, Row, Tab, Nav } from "react-bootstrap";
import BgImg from "../../images/cloud-support-and-maintenance-services/platform_support.webp";

function Zerohassle() {
  return (
    <section
      className="redefinepatient_services zero_hassle_dubai cloud_support_platform p-100 tekgrip_section"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2>Platform-Specific Cloud Support Services</h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <p>
              We bring together 634 dedicated cloud professionals to help our
              clients thrive – so we can empower you with the cloud service you
              have deployed. 
            </p>
          </Col>
        </Row>
        <Row className="mt-lg-5 mt-md-3 md-sm-2">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="tekgrip_tabs"
          >
            <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
              <Tab.Container id="" defaultActiveKey="0">
                <Row>
                  <Col xs={12} md={6} lg={4} xl={4} className="redefine_tabs">
                    <Nav variant="pills" className="flex-column">
                      <div className="red_item">
                        <Nav.Item>
                          <Nav.Link eventKey="0">01. IBM Cloud</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="1">
                            02. Google Cloud Platform
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="2">03. Microsoft Azure</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="3">
                            04. Amazon Web Services (AWS)
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="4">
                            05. Oracle Cloud Infrastructure (OCI)
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="5">06. DigitalOcean</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="6">07. Alibaba Cloud</Nav.Link>
                        </Nav.Item>
                      </div>
                    </Nav>
                  </Col>
                  <Col xs={12} md={6} lg={8} xl={8}>
                    <Tab.Content>
                      <Tab.Pane eventKey="0">
                        <h3 style={{ color: "#F47A1F" }}>IBM Cloud</h3>
                        <p>
                          With IBM Cloud, your organization has made the most
                          powerful choice if you have a strong, complex hybrid
                          IT environment. We have a 360-degree IBM Cloud support
                          team and dedicated professionals for these core
                          modules:
                        </p>
                        <ul>
                          <li>IBM Cloud Hyper Protect Virtual Servers</li>
                          <li>IBM Cloud Code Engine</li>
                          <li>IBM Cloud Object Storage (COS) Gateway</li>
                          <li>IBM Cloud Databases for PostgreSQL</li>
                        </ul>
                      </Tab.Pane>
                      <Tab.Pane eventKey="1">
                        <h3 style={{ color: "#F47A1F" }}>
                          Google Cloud Platform
                        </h3>
                        <p>
                          With GCP configuration and support, we are helping
                          clients turn their daily activities into
                          enterprise-wide solution.
                        </p>
                        <ul>
                          <li>Cloud Run</li>
                          <li>BigQuery</li>
                          <li>Cloud TPU (Tensor Processing Unit)</li>
                          <li>Cloud Spanner</li>
                        </ul>
                      </Tab.Pane>
                      <Tab.Pane eventKey="2">
                        <h3 style={{ color: "#F47A1F" }}>Microsoft Azure</h3>
                        <p>
                          TekRevol will help you maintain Azure so it naturally
                          fits your Microsoft ecosystem and works smoothly for
                          your internal and external stakeholders
                        </p>
                        <ul>
                          <li>Azure Functions</li>
                          <li>Azure Active Directory (AAD)</li>
                          <li>Azure Cosmos DB</li>
                          <li>Azure App Service</li>
                        </ul>
                      </Tab.Pane>
                      <Tab.Pane eventKey="3">
                        <h3 style={{ color: "#F47A1F" }}>
                          Amazon Web Services (AWS)
                        </h3>
                        <p>
                          TekRevol has experienced AWS to be the most extensive
                          cloud provider for businesses that need one-stop
                          solutions to power storage and security in large
                          organizations. We offer specialized cloud support for
                          modules including but not limited to:
                        </p>
                        <ul>
                          <li>AWS Lambda</li>
                          <li>Amazon S3 Glacier</li>
                          <li>Amazon Kinesis Firehose</li>
                          <li>Amazon Aurora</li>
                        </ul>
                      </Tab.Pane>
                      <Tab.Pane eventKey="4">
                        <h3 style={{ color: "#F47A1F" }}>
                          Oracle Cloud Infrastructure (OCI)
                        </h3>
                        <p>
                          Oracle Cloud Infrastructure is the ideal choice for
                          businesses that have already deployed Oracle as their
                          major ERP. TekRevol’s dedicated Oracle practitioners
                          and support professionals can help you manage:
                        </p>
                        <ul>
                          <li>Oracle Functions</li>
                          <li>Oracle Autonomous Database</li>
                          <li>Oracle Container Engine for Kubernetes (OKE)</li>
                          <li>
                            Oracle Cloud Object Storage (OCI Object Storage)
                          </li>
                        </ul>
                      </Tab.Pane>
                      <Tab.Pane eventKey="5">
                        <h3 style={{ color: "#F47A1F" }}>DigitalOcean</h3>
                        <p>
                          For medium-sized entities still navigating the cloud
                          for better organizational management, DigitalOcean
                          offers a business-friendly and economical cloud
                          infrastructure.
                        </p>
                        <ul>
                          <li>DigitalOcean Kubernetes</li>
                          <li>DigitalOcean Block Storage</li>
                          <li>DigitalOcean Marketplace</li>
                        </ul>
                      </Tab.Pane>

                      <Tab.Pane eventKey="6">
                        <h3 style={{ color: "#F47A1F" }}>Alibaba Cloud</h3>
                        <p>
                          TekRevol’s clients currently utilizing Alibaba Cloud
                          say find it to be the most seamless and
                          easy-to-integrate technology for existing Alibaba
                          ecosystem. If you want to experience the power of this
                          growing cloud tech, we can support you in configuring
                          and managing these core modules:
                        </p>
                        <ul>
                          <li>Elastic Compute Service (ECS)</li>
                          <li>Alibaba Cloud Container Service (AKS)</li>
                          <li>Object Storage Service (OSS)</li>
                          <li>Analytic Data Lake (ADL)</li>
                        </ul>
                      </Tab.Pane>
                    </Tab.Content>
                  </Col>
                </Row>
              </Tab.Container>
            </Col>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Zerohassle;
